"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const GlobalStateProvider_1 = require("./GlobalStateProvider");
const Loading_1 = __importDefault(require("./Loading"));
require("./assest/css/all.scss");
const eventManager_1 = __importDefault(require("./eventManager"));
const StreamingContainer_1 = require("./features/DST/DSTT007/component/DSTT007_List_Child/StreamingContainer");
const AdminMain_1 = require("./features/admin/AdminMain");
const account_1 = require("./features/base/account");
const Login2_1 = require("./features/base/account/component/Login2");
const app_1 = require("./features/base/app");
const layout_1 = require("./features/base/layout");
const popup_1 = require("./features/base/popup");
const i18next_1 = __importDefault(require("./lang/i18next"));
require("./redux/app/middleware.any");
require("./redux/app/reducers.any");
const store_1 = __importDefault(require("./redux/store"));
const action_1 = require("./features/menu/action");
require("moment/locale/ko"); // 한국어 로케일 추가
const moment_1 = __importDefault(require("moment"));
const LoginAdmin_1 = require("./features/base/account/component/LoginAdmin");
moment_1.default.locale('ko'); // 한국어 설정
window.APP =
    {
        eventManager: eventManager_1.default,
        deviceType: 'desktop',
    } || {};
const App = react_1.default.memo(() => {
    const queryClient = new react_query_1.QueryClient();
    const store = (0, store_1.default)();
    return (react_1.default.createElement(react_i18next_1.I18nextProvider, { i18n: i18next_1.default },
        react_1.default.createElement(react_query_1.QueryClientProvider, { client: queryClient },
            react_1.default.createElement(react_redux_1.Provider, { store: store },
                react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loading_1.default, { defaultLoading: true }) },
                    react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                        react_1.default.createElement(GlobalStateProvider_1.GlobalProvider, null,
                            react_1.default.createElement(RouterApp, null))))))));
});
exports.default = App;
const RouterApp = react_1.default.memo(() => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { classesId } = (0, GlobalStateProvider_1.useGlobalState)();
    const load = (0, react_redux_1.useSelector)((state) => state['base/app'].isLoad);
    // Function to clear cache
    const clearCache = () => {
        if ('caches' in window) {
            caches.keys().then(names => {
                names.forEach(name => {
                    caches.delete(name);
                });
            });
        }
    };
    const setVh = () => {
        const vh = Math.floor(window.innerHeight * 0.01 * 100) / 100;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    (0, react_1.useEffect)(() => {
        clearCache();
        setVh();
        const ua = navigator.userAgent;
        const isIpad = /iPad/.test(ua) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        const isIpadChrome = isIpad && /CriOS/.test(ua);
        document.documentElement.classList.toggle('is-ipad-chrome', isIpadChrome);
        window.addEventListener('resize', setVh);
        return () => {
            document.documentElement.classList.remove('is-ipad-chrome');
            window.removeEventListener('resize', setVh);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        dispatch((0, app_1.appWillLoad)());
        return () => {
            dispatch((0, app_1.appWillUnmount)());
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (classesId) {
            dispatch((0, app_1.setClassesId)());
        }
    }, [classesId]);
    const handlerUpdateMenu = (menu, isMain = false) => {
        if (menu === 'logout') {
            (0, app_1.closeWindow)();
            return;
        }
        else if (menu === 'accept') {
            navigate('/accept');
            (0, app_1.closeWindow)();
            return;
        }
        else if (menu === 'error') {
            navigate('/error');
            (0, app_1.closeWindow)();
            return;
        }
        dispatch((0, action_1.changeMenuFromName)(menu, isMain));
    };
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('updateMenu', handlerUpdateMenu);
        return () => {
            APP.eventManager.unsubscribe('updateMenu', handlerUpdateMenu);
        };
    }, []);
    if (!load && !(location.pathname.includes('accept') || location.pathname.includes('error')))
        return react_1.default.createElement(Loading_1.default, { defaultLoading: true });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement("iframe", { src: "https://klassmate.dev.meetmate.co.kr", style: {
                        width: '100%',
                        height: '100%',
                        outline: 'none',
                    } }) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/admin", element: react_1.default.createElement(LoginAdmin_1.LoginAdmin, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/admin-page", element: react_1.default.createElement(AdminMain_1.AdminMain, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/login", element: react_1.default.createElement(account_1.Login, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/dev", element: react_1.default.createElement(Login2_1.Login2, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/class/*", element: react_1.default.createElement(layout_1.MainClasses, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/accept", element: react_1.default.createElement(account_1.ErrorPage, { message: "\uC811\uADFC\uC774 \uBD88\uAC00\uB2A5\uD55C \uD398\uC774\uC9C0\uC785\uB2C8\uB2E4. \uB2E4\uC2DC \uB85C\uADF8\uC778\uD574\uC8FC\uC138\uC694." }) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/error", element: react_1.default.createElement(account_1.ErrorPage, { message: "\uC911\uBCF5 \uB85C\uADF8\uC778\uC744 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uB85C\uADF8\uC778 \uD574\uC8FC\uC138\uC694." }) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/player/*", element: react_1.default.createElement(StreamingContainer_1.StreamingContainer, null) })),
        react_1.default.createElement(Loading_1.default, null),
        react_1.default.createElement(popup_1.PopupContainer, null)));
});
